"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAccessTokenExpired = exports.getCachedArchiveUser = exports.setUserInfo = exports.getUserInfo = exports.setAccessToken = exports.getDecodedAccessToken = exports.getAccessToken = exports.resetLogin = exports.isLoggedIn = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var jwt_decode_1 = __importDefault(require("jwt-decode"));

var constants_1 = require("../constants");

var isLoggedIn = function isLoggedIn() {
  if (typeof window !== 'undefined') {
    var accessToken = (0, exports.getAccessToken)();
    return accessToken && (0, exports.getAccessToken)().length > 0 && !(0, exports.isAccessTokenExpired)(accessToken);
  }

  return false;
};

exports.isLoggedIn = isLoggedIn;

var resetLogin = function resetLogin() {
  if (typeof window !== 'undefined') {
    (0, basic_frontend_common_1.clearLocalStorage)();
    return true;
  }

  return false;
};

exports.resetLogin = resetLogin;

var getAccessToken = function getAccessToken() {
  if (typeof window !== 'undefined') {
    return (0, basic_frontend_common_1.getStorageItem)(constants_1.ACCESS_TOKEN_KEY);
  }

  return null;
};

exports.getAccessToken = getAccessToken;

var getDecodedAccessToken = function getDecodedAccessToken() {
  if (typeof window !== 'undefined') {
    var token = (0, basic_frontend_common_1.getStorageItem)(constants_1.ACCESS_TOKEN_KEY);
    return token ? (0, jwt_decode_1["default"])(token) : null;
  }

  return null;
};

exports.getDecodedAccessToken = getDecodedAccessToken;

var setAccessToken = function setAccessToken(token) {
  if (typeof window !== 'undefined') {
    if (!(0, exports.getAccessToken)()) {
      (0, basic_frontend_common_1.setStorageItem)(constants_1.ACCESS_TOKEN_KEY, token);
    }

    return true;
  }

  return false;
};

exports.setAccessToken = setAccessToken;

var getUserInfo = function getUserInfo() {
  if (typeof window !== 'undefined') {
    var userInfo = (0, basic_frontend_common_1.getStorageItem)(constants_1.USER_INFO_KEY);
    var userInfoJson = JSON.parse(userInfo);

    if (!userInfo) {
      return null;
    }

    var userInfoObject = {
      EmailAddress: userInfoJson.email,
      UserName: userInfoJson.name,
      NickName: userInfoJson.nickname,
      Sub: userInfoJson.sub
    };
    return userInfoObject;
  }

  return null;
};

exports.getUserInfo = getUserInfo;

var setUserInfo = function setUserInfo(userInfo) {
  if (typeof window !== 'undefined') {
    if (!(0, exports.getUserInfo)()) {
      (0, basic_frontend_common_1.setStorageItem)(constants_1.USER_INFO_KEY, userInfo);
    }

    return true;
  }

  return false;
};

exports.setUserInfo = setUserInfo;

var getCachedArchiveUser = function getCachedArchiveUser() {
  if (typeof window !== 'undefined') {
    var userInfo = (0, basic_frontend_common_1.getStorageItem)(constants_1.USER_INFO_KEY);
    var userInfoJson = JSON.parse(userInfo);
    var decodedAccessToken = (0, exports.getDecodedAccessToken)();
    var decodedAccessTokenJson = decodedAccessToken ? JSON.parse(userInfo) : null;
    console.log('userInfo: ', userInfo);
    var archiveUser = {
      EmailAddress: userInfoJson.email,
      UserName: userInfoJson.name,
      NickName: userInfoJson.nickname,
      Sub: userInfoJson.sub,
      //
      Permission: decodedAccessTokenJson.Permissions,
      UserType: decodedAccessTokenJson.UserType,
      Id: decodedAccessTokenJson.Id,
      LastLogin: decodedAccessTokenJson.LastLogin,
      LoginCounter: decodedAccessTokenJson.LoginCounter,
      RegistrationDate: decodedAccessTokenJson.RegistrationDate,
      City: decodedAccessTokenJson.City,
      Country: decodedAccessTokenJson.Country,
      DateOfBirth: decodedAccessTokenJson.DateOfBirth,
      FirstName: decodedAccessTokenJson.FirstName,
      Number: decodedAccessTokenJson.Number,
      PostCode: decodedAccessTokenJson.PostCode,
      Street: decodedAccessTokenJson.Street,
      SurName: decodedAccessTokenJson.SurName
    };
    console.log('archiveUser: ', archiveUser);
    return archiveUser;
  }

  return null;
};

exports.getCachedArchiveUser = getCachedArchiveUser;

var isAccessTokenExpired = function isAccessTokenExpired(token) {
  var expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
};

exports.isAccessTokenExpired = isAccessTokenExpired;

var getTokenExpirationDate = function getTokenExpirationDate(encodedToken) {
  var token = (0, jwt_decode_1["default"])(encodedToken);

  if (!token.exp) {
    return null;
  }

  var date = new Date(0);
  date.setUTCSeconds(token.exp);
  return date;
};